export { default as Image, imageRoundedVariants, imageRatioVariants } from './Image.component'
export * from './components/ImageWrapper'
